// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YEvB","content":"styles_content__3nYu1"};